<template>
    <section class="table-wrapper">
        <div ref="slider" class="slider">
            <table class="data-table">
                <thead>
                    <tr>
                        <th v-if="!!rowNumbers" class="row-number">#</th>
                        <th
                            v-for="(item, i) in table.header"
                            :key="[-1, i].toString()"
                            :class="{
                                selected: i === selected,
                                reversed: i === selected && reverse,
                            }"
                            @click="selectColumnToSort(i)"
                        >
                            <span>{{ item }}</span>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(row, j) in rows" :key="[j, -1].toString()">
                        <td v-if="rowNumbers === 'number'" class="row-number">
                            {{ j + 1 }}
                        </td>
                        <td v-if="rowNumbers === 'cup'" class="row-number">
                            <span
                                v-if="j < 3"
                                :class="[
                                    'icon',
                                    'material-symbols-outlined',
                                    'cup' + (j + 1),
                                ]"
                            >
                                workspace_premium
                            </span>
                        </td>
                        <td v-for="(cell, i) in row" :key="[j, i].toString()">
                            {{ displayCell(cell, i) }}
                        </td>
                    </tr>
                    <tr v-if="size === 0">
                        <td class="empty" :colspan="table.header.length">
                            No data to show.
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div
            v-if="!expanded && size > compact"
            class="table-expand"
            @click="expanded = true"
        >
            {{ size - compact }} more row{{ size - compact > 1 ? "s" : "" }},
            expand
        </div>
    </section>
</template>
<script>
import BaseDrag from "js/components/base/BaseDrag.js";

export default {
    name: "DataTable",
    extends: BaseDrag,
    props: {
        table: {
            type: Object,
            required: true,
            default: () => {
                return {};
            },
        },
        compact: {
            type: Number,
            default: 10,
        },
        unsortable: {
            type: Boolean,
            default: false,
        },
        rowNumbers: {
            type: String,
            default: "",
        },
        sortColumn: {
            type: Number,
            default: undefined,
        },
    },
    data() {
        return {
            selected: "",
            reverse: false,
            expanded: false,
            data: [],
        };
    },
    computed: {
        size() {
            return this.data.length;
        },
        rows() {
            return this.expanded ? this.data : this.data.slice(0, this.compact);
        },
    },
    watch: {
        table() {
            this.initSort();
        },
    },
    mounted() {
        this.selected = -1;
        this.reverse = false;
        this.expanded = false;
        this.data = this.table.body;
        this.initSort();
    },
    methods: {
        initSort() {
            if (this.sortColumn === undefined) {
                return;
            }
            const column = Math.abs(this.sortColumn);
            this.selectColumnToSort(column);
            if (this.sortColumn < 0) {
                this.data.reverse();
                this.reverse = true;
            }
        },
        selectColumnToSort(col) {
            if (this.unsortable) {
                return;
            }
            if (col === this.selected) {
                this.data.reverse();
                this.reverse = !this.reverse;
                return;
            } else {
                this.reverse = false;
            }

            this.selected = col;
            this.data.sort((row1, row2) => {
                if (row1[col] === null) {
                    return true;
                }
                if (row2[col] === null) {
                    return false;
                }
                if (typeof row1[col] === "string") {
                    const [a, b] = [
                        row1[col].toLowerCase(),
                        row2[col].toLowerCase(),
                    ];
                    return a.localeCompare(b);
                }
                return row1[col] - row2[col];
            });
        },
        displayCell(cell, i) {
            const column = this.table.header[i];
            const prefix = (this.table.prefixes ?? {})[column] ?? "";
            const postfix = (this.table.postfixes ?? {})[column] ?? "";
            const type = (this.table.columns ?? {})[column] ?? "";
            let value = cell;
            if (type === "date") {
                value = this.$formatDate(cell, true);
            } else if (type === "currency") {
                value = cell.toLocaleString("en-US");
            }
            return `${prefix}${value}${postfix}`;
        },
    },
};
</script>
